<script setup>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

// Feedback Data
const feedbacks = [
  {
    desktopImg: "8",
    name: "盧小姐",
    position: "上班族",
    starType: "red",
    content:
      "服務親切、有耐心，詢問問題都會仔細回覆，代購的商品若有問題，也都會協助處理，很推薦喔❤️",
    date: "2021.03.24",
  },
  {
    desktopImg: "7",
    name: "林小姐",
    position: "插畫家",
    starType: "red",
    content: "服務好！速度快 價格合理, 專注於批貨平台 👍",
    date: "2022.07.28",
  },
  {
    desktopImg: "1",
    name: "王先生",
    position: "學生",
    starType: "red",
    content: "之前東西卡在海關嚇死 還好客服人員有幫忙解決 很感謝",
    date: "2023.01.13",
  },
  {
    desktopImg: "11",
    name: "謝先生",
    position: "批發業",
    starType: "golden",
    content: "代購經驗都很好,店家也很照顧我們,非常感謝!",
    date: "2022.12.10",
  },
  {
    desktopImg: "5",
    name: "張先生",
    position: "上班族",
    starType: "white",
    content: "有效溝通，且都會密切跟消費者與廠商聯繫！讓人十分安心",
    date: "2021.05.16",
  },
  {
    desktopImg: "2",
    name: "陳先生",
    position: "批發業",
    starType: "golden",
    content: "我妹妹介紹的!滿好用的!回覆也很快!買到變常客哈!!",
    date: "2023.01.13",
  },
];

const getProductImgUrl = (name, ext) => {
  return new URL(
    `../../assets/images/desktop/products/${name}.${ext}`,
    import.meta.url,
  ).href;
};
</script>

<template>
  <section class="feedback-section">
    <div class="gray-square-bg">
      <div class="feedback-header">
        <img src="@/assets/images/desktop/products/quote-left.svg" alt="" />
        <p class="feedback-results">會員回饋</p>
        <img src="@/assets/images/desktop/products/quote-right.svg" alt="" />
      </div>

      <div class="omg-carousel">
        <Carousel :autoplay="4000" :wrap-around="true" class="carousel-one">
          <Slide v-for="(item, index) in feedbacks" :key="index">
            <div class="custom-carousel-slide">
              <div class="carousel-content">
                <picture class="carousel-img">
                  <source
                    media="(min-width: 1060px)"
                    :srcset="getProductImgUrl(item.desktopImg, 'svg')"
                  />
                  <img
                    :src="getProductImgUrl(item.desktopImg, 'png')"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </picture>
                <div class="carousel-text">
                  <div class="carousel-name-pos-wrapper">
                    <div class="carousel-name-pos">
                      <p class="photo-text-name">{{ item.name }}</p>
                      <p class="photo-text-position">{{ item.position }}</p>
                    </div>
                    <img
                      class="stars"
                      :src="getProductImgUrl(item.starType, 'svg')"
                      alt=""
                    />
                  </div>
                  <p class="explain">{{ item.content }}</p>
                  <p class="date">{{ item.date }}</p>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </Carousel>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Feedback Section */
.gray-square-bg {
  background-color: #f1f3fa;
  position: relative;
}

.feedback-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
  padding-bottom: 48px;
}

.feedback-results {
  font-weight: 600;
  font-size: 26px;
  color: #343a40;
  white-space: nowrap;
  margin: 0 24px;
}

.omg-carousel {
  width: 343px;
  margin: 0 auto;
  padding-bottom: 124px;
}

.carousel-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-text {
  width: 221px;
}

.carousel-name-pos-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
}

.carousel-name-pos {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-img {
  width: 75px;
  height: 75px;
}

.stars {
  width: 81px;
  margin-top: -5px;
}

.custom-carousel-slide {
  background: #fff;
  border-radius: 30px;
  padding: 32px;
}

.photo-text-name {
  font-size: 20px;
  color: #212529;
  font-weight: 600;
  text-align: left;
  line-height: 0 !important;
  padding-top: 21px;
}

.photo-text-position {
  font-size: 14px;
  color: #868e96;
  padding-top: 8px;
}

.explain {
  font-size: 14px;
  color: #343a40;
}

.date {
  font-size: 14px;
  color: #868e96;
  line-height: 0 !important;
  margin-top: 10px;
}

/* Deep Selectors for vue3-carousel */
:deep(.carousel-one .carousel__prev),
:deep(.carousel-one .carousel__next) {
  opacity: 0.5;
  background-color: #5974ff;
  color: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

@media (min-width: 1060px) {
  .feedback-results {
    font-size: clamp(32px, 2.63vw, 38px);
  }

  .omg-carousel {
    width: 800px;
  }

  .carousel-content {
    flex-direction: row;
    justify-content: center;
  }

  .carousel-content img:first-child {
    padding-bottom: 2rem;
  }

  .carousel-text {
    margin-left: 2rem;
    width: auto;
    text-align: left;
  }

  .carousel-name-pos-wrapper {
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1rem;
    width: 100%;
  }

  .carousel-name-pos {
    align-items: flex-start;
  }

  .carousel-img {
    width: 120px;
    flex-shrink: 0;
    height: auto;
  }

  .stars {
    margin-top: 0;
    padding-bottom: 1rem;
    width: auto;
  }

  .photo-text-name {
    font-size: 22px;
    padding-top: 0;
  }

  .photo-text-position {
    font-size: clamp(14px, 1.11vw, 16px);
    padding-top: 0;
  }

  .explain {
    font-size: 16px;
    width: 400px;
  }

  .date {
    font-size: clamp(14px, 1.11vw, 16px);
    text-align: right;
  }
}
</style>
